<script lang="ts">
import { computed, defineComponent } from 'vue'
export default defineComponent({
  name: 'LoadingSpinner',
  props: {
    strokeWidth: { type: Number, default: 5 },
    centered: { type: Boolean, default: true },
    size: { type: Number, default: undefined }
  },
  setup (props) {
    return {
      style: computed(() => (props.size
        ? {
            width: `${props.size / 16}rem`,
            height: `${props.size / 16}rem`
          }
        : null))
    }
  }
})
</script>

<template>
  <svg :class="{ 'absolute-center': centered }" viewBox="0 0 50 50" :style="style">
    <circle cx="25" cy="25" r="20" fill="none" :stroke-width="strokeWidth"></circle>
  </svg>
</template>

<style lang="scss" scoped>
svg {
  display: inline-block;
  width: 1em;
  height: 1em;
}

circle {
  animation: dash 1.5s ease-in-out infinite;
  stroke: currentColor; // stylelint-disable-line
  stroke-linecap: square;
  transform-origin: center;
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
    transform: rotate(0deg);
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
    transform: rotate(360deg);
  }
}
</style>
